import { create } from 'zustand';

export type Tool = 'select' | 'hand';

const TOOL_KEY = 'codeframe.tool';

function load(): Tool {
  try {
    return localStorage.getItem(TOOL_KEY) === 'hand' ? 'hand' : 'select';
  } catch {
    return 'select';
  }
}

interface ToolState {
  /** Active canvas tool. Select = drag-lasso; Hand = drag-pan. */
  tool: Tool;
  /** True while Space is held — a temporary Hand override regardless of tool. */
  spaceHeld: boolean;
  setTool: (t: Tool) => void;
  setSpaceHeld: (v: boolean) => void;
}

export const useToolStore = create<ToolState>((set) => ({
  tool: load(),
  spaceHeld: false,
  setTool: (tool) => {
    try { localStorage.setItem(TOOL_KEY, tool); } catch { /* ignore */ }
    set({ tool });
  },
  setSpaceHeld: (spaceHeld) => set({ spaceHeld }),
}));

/** Whether the canvas should pan on left-drag right now (Hand tool or Space). */
export function isPanMode(): boolean {
  const s = useToolStore.getState();
  return s.tool === 'hand' || s.spaceHeld;
}
